import Vue from 'vue';
import Router from 'vue-router';
import routes from './routes';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes,
  scrollBehavior: (to, from, savedPosition) => {
    const position = {};
    if (savedPosition) {
      position.x = savedPosition.x;
      position.y = savedPosition.y;

      return new Promise(resolve => {
        this.app.$root.$once('scrollBeforeEnter', () => {
          resolve(position);
        });
      });
    } else if (to.hash)
      return { selector: to.hash };
    else
      return { x: 0, y: 0 };
  }
});

export default router;